// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__osyXv","colMaxWidth":"Table_colMaxWidth__1JKhP"};